isConflict